import ProductSpecs from '@elem/compCommon/ProductConstructor/Specs';

export default function TabSpecs({ productCatagory, productDetail, theme }: { productCatagory: any; productDetail: any; theme: any }) {
    return (
        <>
            <ProductSpecs productCatagory={productCatagory} productDetail={productDetail} theme={theme} />
        </>
    );
}
